var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 44,
    viewBox: "0 0 39 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3674 16.0453C17.3674 13.9899 19.0336 12.3237 21.089 12.3237V34.157H17.3674V16.0453Z",
    fill: "#B4006E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42801 43.337C14.635 43.337 21.089 39.3819 21.089 34.175C21.089 28.968 14.635 24.4809 9.42801 24.4809V43.337Z",
    fill: "#4E3FE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 33.9089C0 39.1159 4.22106 43.337 9.42801 43.337V24.4809C4.22106 24.4809 0 28.702 0 33.9089Z",
    fill: "#B4006E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42801 43.3191C14.635 43.3191 21.089 39.3641 21.089 34.1571C21.089 28.9502 14.635 24.4631 9.42801 24.4631V43.3191Z",
    fill: "#EC3066"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.156 7.07872C17.3713 9.436 17.251 12.6791 17.4261 15.3946C17.5407 17.1705 19.0351 18.195 20.6874 17.534C21.9279 17.0378 24.9864 16.0106 28.708 14.8941C33.1939 13.5483 37.6128 11.9168 38.012 7.32684C38.5082 1.62041 36.5233 -0.73658 29.3282 1.49636C22.1332 3.72929 21.8258 3.55222 19.156 7.07872Z",
    fill: "#EC3066"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e127bdfe56081b6c5406f8039cd45649.svg";
export { ForwardRef as ReactComponent };